import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { api } from '../utils/Api'
import { Typography, Flex, Button } from 'antd'
import Layout from '../layout/Layout'
import { CustomSpinner, CustomTable } from '../utils/CustomComponents'
import {
    EditFilled,
    PlusCircleFilled
} from '@ant-design/icons'
const { Text } = Typography

const LogisticsDriverList = ({history}) => { 
    
    const [loading, setLoading] = useState(true)
    const [logisticsDriverList, setLogisticsDriverList] = useState([])

    /**
     ** Options header (columns)
    */
    const columns = [
        {
            title: '',
            dataIndex: 'edit',
            width: 100,
            render: (_, record) => {
              return <Button 
              type="primary" 
              icon={<EditFilled twoToneColor={'white'}/>} 
              onClick={e=> history.push(`/logisticsdriver/${record.id}`)}
              />
            }
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        {
            title: 'License',
            dataIndex: 'license',
            key: 'license',
            render: (value) => {
                return <Text>{value}</Text>
            }
        },
        
    ]

    useEffect(() => {
        getLogisticsDriverList()
    }, [])
    
    const getLogisticsDriverList = async() => {
        setLoading(true)

        const url = api + '/logisticsdriver/list'
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            let list = []
            data.map((item, index) => {
                list.push({
                    key: index,
                    id: item._id,
                    name: item.name,
                    phone: item.phone,
                    license: item.license,
                })
            })
            setLogisticsDriverList(list)
            setLoading(false)
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const addNewLogisticsDriver = () => {
        history.push('/newlogisticsdriver')
    }
    
    const RenderTable = () => {
        return <Flex gap={'middle'} vertical>
            <Button
                onClick={addNewLogisticsDriver}
                type="primary"
                size='large'
                style={{
                    width: 200,
                }}
                icon={<PlusCircleFilled />}
            >
                New Logistics Driver
            </Button>
            <CustomTable 
            columns={columns}
            data={logisticsDriverList}
            />
        </Flex>
    }

    return (
        <Layout
            title='Logistics Drivers'
            description='Driver List'
        >
            <Flex vertical gap={'large'}>
                {
                    loading ? <CustomSpinner/> : <RenderTable/>
                } 
            </Flex>
        </Layout>
    )
}

export default LogisticsDriverList